/* PabDer — Wishlist (client-side, saved in this browser via localStorage) + wishlist drawer */
(function () {
  var KEY = 'pd_wishlist';
  var drawer, scrim, body, closeBtn, trigger, badge;

  function $(id) { return document.getElementById(id); }

  function readList() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      // migrate legacy format (array of plain id strings) to {id, handle}
      return list.map(function (item) {
        return typeof item === 'string' ? { id: item, handle: null } : item;
      });
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* ignore */ }
  }

  function isSaved(id) {
    return readList().some(function (item) { return item.id === String(id); });
  }

  function paint(el, saved) {
    el.classList.toggle('is-active', saved);
    el.setAttribute('aria-pressed', saved ? 'true' : 'false');
    el.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
  }

  function paintAllHearts() {
    document.querySelectorAll('.pd-prod__action--wish[data-id]').forEach(function (el) {
      paint(el, isSaved(el.getAttribute('data-id')));
    });
  }

  function updateBadge() {
    var count = readList().length;
    if (!badge) badge = $('wishBadge');
    if (!badge) return;
    badge.textContent = count || '';
    badge.style.display = count > 0 ? 'flex' : 'none';
  }

  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function money(cents) {
    if (window.PDCurrency && window.PDCurrency.isForeign()) {
      return window.PDCurrency.formatUsd(cents / 100);
    }
    var amount = (cents / 100).toFixed(2);
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      var fmt = window.Shopify.moneyFormat || '₱{{amount}}';
      return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }
    return '₱' + amount;
  }

  function openDrawer() {
    refreshDrawer();
    drawer.classList.add('open');
    scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    scrim.classList.remove('open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
  }

  function renderEmpty() {
    body.innerHTML = '<div class="wl-drawer__empty">' +
      '<svg viewBox="0 0 24 24"><path d="M12 20.5s-7.7-4.8-10-9.4C.4 7.7 2.3 4 6 4c2.2 0 3.7 1.2 6 3.6C14.3 5.2 15.8 4 18 4c3.7 0 5.6 3.7 4 7.1-2.3 4.6-10 9.4-10 9.4z"/></svg>' +
      '<p>Your wishlist is empty.</p>' +
      '<a href="/collections/women" class="btn btn-outline">Continue Shopping</a>' +
      '</div>';
  }

  function renderLine(p, id) {
    var v = p.variants[0];
    var img = p.featured_image || (p.images && p.images[0]);
    var imgTag = img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="' + esc(p.title) + '">' : '';
    return '<div class="wl-line pd-prod" data-handle="' + esc(p.handle) + '">' +
      '<a class="wl-line__img" href="' + p.url + '">' + imgTag + '</a>' +
      '<div class="wl-line__info">' +
        '<div class="wl-line__name">' + esc(p.title) + '</div>' +
        '<div class="wl-line__price">' + money(v.price) + '</div>' +
        '<div class="wl-line__actions">' +
          '<button type="button" class="btn btn-outline wl-line__add" onclick="pdQuickAdd(this)">Add to Bag</button>' +
          '<button type="button" class="wl-line__remove" data-id="' + esc(id) + '" onclick="pdWishRemove(this)">Remove</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function refreshDrawer() {
    var list = readList();
    if (!list.length) { renderEmpty(); return; }
    var loadable = list.filter(function (item) { return item.handle; });
    if (!loadable.length) { renderEmpty(); return; }
    body.innerHTML = '<div class="wl-drawer__loading"><div class="cd-spinner"></div></div>';
    Promise.all(loadable.map(function (item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      products.forEach(function (p, i) {
        if (p) html += renderLine(p, loadable[i].id);
      });
      body.innerHTML = html || '';
      if (!html) renderEmpty();
    });
  }

  window.pdWishToggle = function (btn) {
    var id = btn.getAttribute('data-id');
    if (!id) return;
    var card = btn.closest('.pd-prod');
    var handle = card ? card.getAttribute('data-handle') : null;
    var list = readList();
    var idx = list.findIndex(function (item) { return item.id === String(id); });
    var saved;
    if (idx > -1) { list.splice(idx, 1); saved = false; }
    else { list.push({ id: String(id), handle: handle }); saved = true; }
    writeList(list);
    document.querySelectorAll('[data-id="' + id + '"].pd-prod__action--wish').forEach(function (el) {
      paint(el, saved);
    });
    updateBadge();
  };

  window.pdWishRemove = function (btn) {
    var id = btn.getAttribute('data-id');
    var list = readList().filter(function (item) { return item.id !== id; });
    writeList(list);
    updateBadge();
    paintAllHearts();
    refreshDrawer();
  };

  function init() {
    paintAllHearts();
    updateBadge();

    drawer = $('wlDrawer');
    scrim = $('wlDrawerScrim');
    body = $('wlBody');
    closeBtn = $('wlDrawerClose');
    trigger = $('wishlistDrawerTrigger');
    if (!drawer || !scrim || !body) return;
    if (trigger) trigger.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
